class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = this.querySelector('#unite-predictive-search');
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if(input_length>0){
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = false;
        });
      }else{
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = true;
        });
      }
    }, 300).bind(this));
  }
  onChange() {
    const searchTerm = this.input.value.trim();    
//     if (!searchTerm.length) {
//       this.close();
//       return;    
//     }else{
//       this.open();
//     }
    if(searchTerm.length>0){
      this.getSearchResults(searchTerm);
      this.open();
      $('.unite-zero').hide();
      $('.unite-more').show();
    }else{
	  $('.unite-zero').show();
      $('.unite-more').hide();
    }
  }
  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=article&resources[limit]=10&section_id=unite-predictive-search`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#unite-predictive-search').innerHTML;      
      $('#unite-predictive-search').html(resultsMarkup);
      if (!searchTerm.length) {
        this.close();
      }else{
        this.open();
      }
      if(document.getElementById('SearchValue')){
        document.getElementById('SearchValue').value = searchTerm;
      }     
    })
    .catch((error) => {
      this.close();
      throw error;
    });
  }
  open() {
    $('#unite-predictive-search,.predictive-searchouter').show();
    $('body').addClass('du-open-search');
    $('.unite-zero').hide();
  }
  close() {
    $('#unite-predictive-search').hide();
    $('.unite-zero').show();
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
$('#Search').on('click',function(e){
  $('.predictive-searchouter').show();
  $('body').addClass('du-open-search');
});
$('body').on('click',function(e){   
  var seachbox = $(".u-header-search,.predictive-searchouter");    
  if (!seachbox.is(e.target) && seachbox.has(e.target).length === 0){
    $('.predictive-searchouter').hide();
    $('body').removeClass('du-open-search');
    $('#Search').val('');
  }
});
if($('.flickity-interest').length>0){
  $(".flickity-interest").flickity({
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    autoPlay: 2500,
    wrapAround: true,
  });
}
if($('.flickity-plyslists').length>0){
  $(".flickity-plyslists").flickity({
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    autoPlay: 2500,
    wrapAround: true,
  });
}
$('.playunite').on('click',function (e) {
  e.preventDefault();
  let video = $(this).parents('.video_autoplay').find('video')[0];
  video.play();
  $(this).addClass('hideicon');
});
setTimeout(function(){
  $('.event-slider').each(function(e){
    var thisslider = $(this);
    $(this).flickity({
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      detectContainedEnd:true
    });
    var flktycarousel = $(this).data('flickity');  
    var lastCell = false;
    flktycarousel.on('cellSelect', function(){
      var friction = (flktycarousel.options['friction'] + 0.1) * 1000;
      setTimeout(function(){
        var fullSize = flktycarousel.slideableWidth,
            viewport = flktycarousel.size['width'],
            cellWidth = flktycarousel.selectedSlide['outerWidth'],
            movedX = Math.round(flktycarousel.x);

        fullSize = Math.round(fullSize);
        cellWidth = Math.round(cellWidth);
        movedX = Math.abs(movedX);
        var total = Math.round((viewport + movedX) / 100) * 100,
            fullSize = Math.round(fullSize / 100) * 100;
        thisslider.find('.flickity-prev-next-button.next').prop('disabled', false);
        if(total >= fullSize){
          if(lastCell == true)
            flktycarousel.select(0);
          lastCell = true;
          console.log(lastCell,$(this));
          if(lastCell == true){
            console.log('if');
            thisslider.find('.flickity-prev-next-button.next').prop('disabled', true);
          }
        }
        if(movedX < 70)
          lastCell = false

          }, friction);
    });
  });
},2000);
$('.unite-collboration').each(function(e){
  $(this).flickity({
    cellAlign: 'left',
    contain: true,
    pageDots: false,
  });
});
$('.latest-blog-list').flickity({
  cellAlign: 'left',
  contain: true,
  pageDots: false,
  autoPlay: 2500,
  wrapAround: true,
});
$('.unite-banner-slider').each(function(e){
  $(this).flickity({
    pageDots: true,
    wrapAround: true,
    draggable: true
  });
});
$('.slider-unite-about').each(function(e){
  $(this).flickity({
    pageDots: true,
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    autoPlay: 5000
  });
});
$(document).on('click','.daily-h-list li a,.daily-h-listmob a',function(e){
  e.preventDefault();
  var data_url = $(this).data('url');
  var data_title = $(this).data('title');
  $('[data-title="'+data_title+'"]').closest('li').hide().siblings('li').show();
  $(this).closest('.unite-t-header').find('.daily-h-title').text(data_title);
  $(this).closest('.daily-h-dropdown').find('.daily-h-list').slideUp();
  $(this).closest('.daily-h-dropdown').removeClass('active');
  var bloglimit = $(this).closest('.setion-latets-story').find('.latest-blog-outer').data('limit');
  $.ajax({
    url: data_url + "?view=json",
    dataType: "html",
    success: function (blog) {
      var blogdata = JSON.parse(blog);
      var article = blogdata.blog;
      var bloglen = article.length;
      if(bloglen>bloglimit){
        var final_arry = bloglimit;
      }else{
        var final_arry = bloglen;
      }
      $('.latest-blog-outer').html('');
      function carouselloop(i){
        return `
        <div class="col-md-4">
          <div class="uniteb-grid dunite-bgrid">
            <a href="${article[i].url}" class="square-unite unite-box unite-ovarlay">
			  <div class="uniteb-gridimgbox">
              <img src="${article[i].thumbnail}" alt="${article[i].title}" loading="lazy">
			  </div>
              <div class="sq-unite-box-meta">
                <p>${article[i].publish_date}</p>
                <h3>${article[i].title}</h3>
				<div class="d-block d-lg-none">
                  <div class="grid-unite-des unitedes-space">${article[i].content}</div>
                </div>
                <div class="sq-flex-space">
                  <div>
                    <div>${article[i].blog_title}</div>
                    <div class="gridtag-left">${article[i].author}</div>
                  </div>
                  <div class="${article[i].authorclass}">${article[i].time}</div>
              	</div>
              </div>
            </a>
          </div>
        </div>
		`;
      }
      var new_carousel = '';
      new_carousel += '<div class="latest-blog-list unite-collboration rowbefore">';
      for(i=0;i<final_arry;i++){
        new_carousel += carouselloop(i);
      }
      new_carousel += '</div>';        
      $('.latest-blog-outer').html(new_carousel); 
      $('.latest-blog-list').flickity({
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        autoPlay: 2500,
        wrapAround: true,
      });
    }
  });
});
$('.unite-menubar').on('click',function(e){
  $('body').toggleClass('unite-menuopen');
  $('body').removeClass('open-umob-search');
});
$('.sunite-b-video').each(function(e){
  var mediawrap = $(this).attr('id');
  var videoid = $(this).data('id');
  var player = jwplayer(mediawrap);
  var playerautplay = $(this).data('autoplay');
  if(playerautplay == true){    
    player.setup({
      playlist: 'https://cdn.jwplayer.com/v2/media/'+videoid,
      controls: true,
      repeat:true,
      autostart: "viewable",
      mute: true 
    });
  }else{
    player.setup({
      playlist: 'https://cdn.jwplayer.com/v2/media/'+videoid,
      //controls: false,
      repeat:true,
      //autostart: "viewable",
      mute: true 
    });
  }
});
$('.volumeon').on('click',function(e){
  let video = $(this).parents('.media-list').find('video')[0];
  video.muted = true;
  $('.volumeoff').show();
  $(this).hide();
});
$('.volumeoff').on('click',function(e){
  let video = $(this).parents('.media-list').find('video')[0];
  video.muted = false;
  $('.volumeon').show();
  $(this).hide();
});
$('.fullvideo_screen').on('click',function(e){
  let video = $(this).parents('.media-list').find('video')[0];
  if(video.requestFullscreen){
    video.requestFullscreen();
  }else if(video.webkitRequestFullscreen){
    video.webkitRequestFullscreen();
  }else if(video.mozRequestFullScreen){
    video.mozRequestFullScreen();
  }else if(video.msRequestFullscreen){
    video.msRequestFullscreen();
  }
  video.play();
});
$(document).on("scroll", function(){
  var pixels = $(document).scrollTop();
  var articleheight = $('.section-article-template').height();
  var pageHeight = articleheight - $(window).height();
  var progress = 100 * pixels / pageHeight;
  $(".article_scroll").width(progress + '%');
});
$(window).on('scroll',function(e){
  var body_scroll = $(window).scrollTop()+($(window).height()/2);
  var body_scrollsec = $(window).scrollTop();
  if($(window).width() > 992){
    var body_scroll = $(window).scrollTop()+($(window).height()/2);
    $('.dploop').each(function(e){
      var article_loop = $(this).offset().top;
      if(body_scroll > article_loop  && body_scrollsec < article_loop){
        $(this).addClass('active');
        var img_src = $(this).data('image');
        if(img_src != 'blank'  ){
          $('.meta-artcile-img').html('<img src="'+img_src+'" loading="lazy" />');
        }
      }else{
        $(this).removeClass('active');
      }
    });
  }else{
    var body_scroll = $(window).scrollTop()+($(window).height());
    $('.dploop').each(function(e){
      var article_loop = $(this).offset().top;
      if(body_scroll > article_loop  && body_scrollsec < article_loop){
        $(this).addClass('active');
        var img_src = $(this).data('image');
        if(img_src != 'blank'  ){
          $('.meta-artcile-img').html('<img src="'+img_src+'" loading="lazy" />');
        }
      }else{
        $(this).removeClass('active');
      }
    });
  }  
  if($('.videoanimation').length>0){
    $('.videoanimation').each(function(e){
      var article_next_div = $(this).next('div').offset().top-$(window).height();
      var this_div = $(this);
      if(body_scrollsec<article_next_div){
        this_div.css({transform: 'scale('+(100 - body_scrollsec/25)/100+')'});
      }
    });
  }
  if($('.bvideoanimation').length>0){
    var article_next_div = $('.nextblogbnr').offset().top-$(window).height();
    var this_div = $(this);
    if(body_scrollsec<article_next_div){
      $('.bvideoanimation').css({transform: 'scale('+(100 - body_scrollsec/25)/100+')'});
    }
  }
});
$('.mob-serach-btn').on('click',function(e){
  e.preventDefault();
  $('body').toggleClass('open-umob-search');
  $('body').removeClass('unite-menuopen');
});
$('.mon-soc-share').on('click',function(e){
	e.preventDefault();
  	$('.mobile-usocial ul').toggleClass('active');
});
var loadintime = $('.unite-loading').attr('data-time');

$(document).ready(function() {
  function Preloader() {
    var preloader = $('.unite-loading');
    preloader.show();
    preloader.delay(loadintime).fadeOut(1000);
  }
  if (!sessionStorage.getItem('doNotShow')) {
    sessionStorage.setItem('doNotShow', true);
    Preloader();
  } else {
    $('.unite-loading').hide();
  }
});
$(document).on('click','.daily-h-button,.daily-h-listmob .daily-h-title',function(e){
  e.preventDefault();
  $(this).closest('.daily-h-dropdown').find('.daily-h-list').slideToggle();
  $(this).closest('.daily-h-dropdown').toggleClass('active');
});